export default __webpack_public_path__ + "static/media/santhosh-jayaram.116afdd1.png";